import FieldsCollection from "../../../fields3/collection/base/fields-collection"
import {FieldType} from "../../../fields3/field-type"
import FieldToggle from "../../../fields3/generic/boolean/toggle/toggle"
import {EntityType} from "../../../gd/const/item"

export default class ProjectPropertiesFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = [{
            fieldId     : 'canCreateTask',
            label       : 'Allow Tasks',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateMeeting',
            label       : 'Allow Meetings',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateEvent',
            label       : 'Allow Events',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateDocument',
            label       : 'Allow Documents',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateDiscussion',
            label       : 'Allow Discussions',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreatePage',
            label       : 'Allow Pages',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateLink',
            label       : 'Allow Links',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateEmbed',
            label       : 'Allow Embeds',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateRequestForms',
            label       : 'Allow Public Forms & Requests',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateAttachments',
            label       : 'Allow Attachments',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'canCreateProject',
            label       : 'Allow Sub-Folders/Projects',
            type        : FieldType.TOGGLE
        }, {
            fieldId     : 'expenses',
            label       : 'Allow Expenses',
            type        : FieldType.TOGGLE
        }/*, {
            fieldId     : 'canCreatePage',
            label       : 'Allow Page',
            type        : FieldType.TOGGLE
        }*/]

        super(fieldsConfig, EntityType.DYNAMIC_MODEL)
    }

    get canCreateTask()         :FieldToggle { return this.get('canCreateTask') as FieldToggle }
    get canCreateMeeting()      :FieldToggle { return this.get('canCreateMeeting') as FieldToggle }
    get canCreateEvent()        :FieldToggle { return this.get('canCreateEvent') as FieldToggle }
    get canCreateDocument()     :FieldToggle { return this.get('canCreateDocument') as FieldToggle }
    get canCreateDiscussion()   :FieldToggle { return this.get('canCreateDiscussion') as FieldToggle }
    get canCreateRequestForms() :FieldToggle { return this.get('canCreateRequestForms') as FieldToggle }
    get canCreateAttachments()  :FieldToggle { return this.get('canCreateAttachments') as FieldToggle }
    get canCreateProject()      :FieldToggle { return this.get('canCreateProject') as FieldToggle }
    get expenses()              :FieldToggle { return this.get('expenses') as FieldToggle }
    // get canCreatePage()         :FieldToggle { return this.get('canCreatePage') as FieldToggle }
    // get canCreateLink()         :FieldToggle { return this.get('canCreateLink') as FieldToggle }
    // get canCreateEmbed()        :FieldToggle { return this.get('canCreateEmbed') as FieldToggle }
}
